module.exports = "<p>\n  view-invig works!\n</p>\n"